import './vehicle-add-item/vehicle-add-item.component';
import './vehicle-add-item/vehicle-add-item.scss';

import './vehicle-classes-display-list/vehicle-classes-display-list.component'
import './vehicle-classes-display-list/vehicle-classes-display-list.scss'

import './vehicle-panel/vehicle-panel.component';
import './vehicle-panel/vehicle-panel.scss';

import './vehicle-select/vehicle-select.component';
import './vehicle-select/vehicle-select.scss';

import './vehicle-type-multiple-select/vehicle-type-multiple-select.component';
import './vehicle-type-multiple-select/vehicle-type-multiple-select.scss';

import './vehicle-type-select/vehicle-type-select.component';
import './vehicle-type-select/vehicle-type-select.scss';

import './vehicles-display-list/vehicles-display-list.component';
import './vehicles-display-list/vehicles-display-list.scss';

import './vehicles-multi-select/vehicles-multi-select.component'
import './vehicles-multi-select/vehicles-multi-select.scss'

import './vehicles-multi-select-list/vehicles-multi-select-list.component';
import './vehicles-multi-select-list/vehicles-multi-select-list.scss';

import './vehicles-table/vehicles-table.component';
import './vehicles-table/vehicles-table.scss';

import './vehicles-table-row/vehicles-table-row.component';
import './vehicles-table-row/vehicles-table-row.scss';

import './vehicles-view/vehicles-view.component';
import './vehicles-view/vehicles-view.scss';
